import { Text } from '@chakra-ui/react'
import { LANGUAGES } from 'commons/constants/language'
import { Spacing, TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

export const LanguageSwitch = () => {
	const { i18n } = useTranslation()

	return (
		<Text
			fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
			fontWeight={600}
			color={TextColors.PRIMARY}
			textDecoration='underline'
			cursor='pointer'
			mt={Spacing.SM}
			onClick={() =>
				i18n.changeLanguage(
					i18n.language === LANGUAGES.FRENCH ? LANGUAGES.ENGLISH : LANGUAGES.FRENCH
				)
			}
		>
			{i18n.language === LANGUAGES.FRENCH ? 'In English, please' : "En français, s'il vous plaît"}
		</Text>
	)
}
